import { render, staticRenderFns } from "./form-notification.html?vue&type=template&id=3744306b&"
import script from "./form-notification.js?vue&type=script&lang=js&"
export * from "./form-notification.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./form-notification-i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fr.coelho%2Fprojects%2Fmanor-repair-vue.git%2Fsrc%2Fcomponents%2Forder%2Fforms%2Fform-notification.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VFlex,VIcon,VSelect,VTextField})
